<template>
  <div>
    <div class="user_body">
      <div class="top_nav">
        <span :class="currentIndex==1?'title2':'title'" @click="navClick(1)">产品订单</span>
        <span :class="currentIndex==2?'title2':'title'" @click="navClick(2)">服务订单</span>
      </div>

      <div class="search_top">
        <!-- 待发货',status:1 -->
        <div class="tabs" v-if="currentIndex==1">
          <span :class="navIndex==-1?'tab_select':'tab_nselect' "  @click="navClick2(-1)">全部订单({{orderIndex.count0}})</span>
          <span class="s_line">|</span>
          <span :class="navIndex==0?'tab_select':'tab_nselect' "  @click="navClick2(0)">待确认({{orderIndex.count1}})</span>
          <span class="s_line">|</span>
          <span  :class="navIndex==2?'tab_select':'tab_nselect' "  @click="navClick2(2)">待收货({{orderIndex.count2}})</span>
          <span class="s_line">|</span>
          <span  :class="navIndex==3?'tab_select':'tab_nselect' "  @click="navClick2(3)">已完成({{orderIndex.count3}})</span>
        </div>
        <div class="tabs" v-if="currentIndex==2">
          <span :class="serveNavIndex==0?'tab_select':'tab_nselect' "  @click="serveNavClick2(0)">全部订单({{serveOrderIndex.count0}})</span>
          <span class="s_line">|</span>
          <span :class="serveNavIndex==1?'tab_select':'tab_nselect' "  @click="serveNavClick2(1)">待确认({{serveOrderIndex.count1}})</span>
          <span class="s_line">|</span>
          <span  :class="serveNavIndex==2?'tab_select':'tab_nselect' "  @click="serveNavClick2(2)">进行中({{serveOrderIndex.count2}})</span>
          <span class="s_line">|</span>
          <span  :class="serveNavIndex==3?'tab_select':'tab_nselect' "  @click="serveNavClick2(3)">已完成({{serveOrderIndex.count3}})</span>
        </div>
        <div class="search-container">
          <el-input
            :placeholder="currentIndex==1?'输入产品名称、订单号':'输入服务名称、订单号'"
            v-model="keyword"
            class="input"
            size="small"
            @keyup.enter.native="handleSearch"
          >
          <i slot="suffix" style="cursor: pointer;" class="el-input__icon el-icon-search" @click="handleSearch"></i>
          </el-input>
        </div>
      </div>

      <div class="order_list" v-if="currentIndex==1" v-loading="loading">
        <div class="order_item" :class="{order_item_success:item.status==3}" v-for="(item,index) in orderList" :key="index">
          <div class="o_t" :class="{'o_t_success':item.status==3}">
            <span class="title2" :class="{
              'title2_success':item.status==3
            }">{{item.statusText}}</span>
            <div class="order_top">
              <span
                class="o_text1"
              >{{item.createtime}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.name}}&nbsp;&nbsp;&nbsp;&nbsp;订单号：{{item.order_no}}</span>
              <div class="o_price">
                <span class="o_text1">应付金额：</span>
                <span class="o_text2" :class="{
                  'o_text2_success':item.status==3
                }">{{item.total_price}}</span>
                <span class="o_text1">元</span>
              </div>
            </div>
          </div>
          <div class="order_info_list">
            <div class="order_info_item" v-for="(goods,index) in item.order_goods" :key="index">
              <img :src="goods.goods.thumb" class="order_img">
              <div class="order_name_pr">
                <span class="o_text3">{{goods.goods.title}}</span>
                <span class="o_text3" v-if="goods.goods.sku_name">{{goods.goods.sku_name}}</span>
                <span class="o_text4">{{goods.goods.price}}元 x {{goods.goods.total}}</span>
              </div>
              <div class="order_btns" v-if="index==0">
                <span class="order_btns1" v-if="item.status==0" @click="toPay(item)">立即确认</span>
                <span class="order_btns1" v-if="item.status==1" @click="remindDelivery(item.id)" >提醒发货</span>
                <span class="order_btns1" v-if="item.status==2" @click="comfirmDelivery(item.id)">确认收货</span>
                <span class="order_btns2" v-if="item.status==3">已完成</span>
                <span class="order_btns2" @click="refund(item)" v-if="item.is_pay==1&&item.refund_status==-1&&item.status!=3">退款</span>
                <span class="order_btns2" @click="toOrderDetail(item.id)">订单详情</span>
              </div>
            </div>
          </div>
        </div>
        <el-empty v-if="orderList.length==0" description="暂无订单"></el-empty>
      </div>

      <div class="order_list" v-if="currentIndex==2" v-loading="loading">
        <div class="order_item" v-for="(item,index) in serveOrderList" :key="index">
          <div class="o_t" :class="{'o_t_success':item.status==3}">
            <span class="title2" :class="{
              'title2_success':item.status==3
            }">{{getServeStatus(item.status,item)}}</span>
            <div class="order_top">
              <span
                class="o_text1" :class="{'o_text1_success':item.status==3}"
              >{{item.createtime}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.name}}&nbsp;&nbsp;&nbsp;&nbsp;订单号：{{item.order_no}}</span>
              <div class="o_price" v-if="item.price">
                <span class="o_text1">应付金额：</span>
                <span class="o_text2">{{item.price}}</span>
                <span class="o_text1">元</span>
              </div>
            </div>
          </div>
          <div class="order_info_list">
            <div class="order_info_item">
              <div class="order_name_pr">
                <span class="o_text3">{{ item.title }}</span>
                <span
                  class="o_text4"
                >{{item.content}}</span>
              </div>
              <div class="order_btns">
                <span class="order_btns1" v-if="item.status==0&&item.is_confirmprice==1" @click="serveConfirm(item)">立即确认</span>
                <span class="order_btns1" v-if="item.status==1" @click="completeServeOrder(item)">确认完成</span>
                <span class="order_btns2" @click="goServeOrderInfo(item)">订单详情</span>
                
                <span class="order_btns3" @click="$router.push('/search?tab=2')">技术支持</span>
                <span class="order_btns3" @click="addstep(item)">问题反馈</span>
              </div>
            </div>
          </div>
          <div class="imae_list">
            <img :src="item" v-for="(item,index) in item.images" :key="index" class="order_img">
          </div>
        </div>
      </div>
      <div class="footer">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage1"
          :page-size="10"
          layout="total, prev, pager, next"
          :total="total"
          small
        ></el-pagination>
      </div>
    </div>
     <!-- 添加进度对话框 -->
     <el-dialog title="添加反馈" :visible.sync="dialogProgressVisible" width="40%">
            <el-form label-width="120px">
                <el-form-item label="反馈标题">
                    <el-input v-model="progressForm.title" placeholder="请输入反馈标题" />
                </el-form-item>
                <el-form-item label="反馈内容">
                    <el-input v-model="progressForm.content" type="textarea" :rows="4" placeholder="请输入反馈详细内容" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogProgressVisible = false">取消</el-button>
                <el-button type="primary" @click="submitProgress">确认</el-button>
            </div>
        </el-dialog>

     <!-- 添加退款对话框 -->
     <el-dialog title="申请退款" :visible.sync="refundDialogVisible" width="40%">
            <el-form label-width="120px" :model="refundForm" :rules="refundRules" ref="refundForm">
                <el-form-item label="退款金额" prop="money">
                    <el-input v-model.number="refundForm.money" placeholder="请输入退款金额" type="number">
                      <template slot="append">元</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="联系电话" prop="mobile">
                    <el-input v-model="refundForm.mobile" placeholder="请输入联系电话" />
                </el-form-item>
                <el-form-item label="退款原因" prop="content">
                    <el-input v-model="refundForm.content" type="textarea" :rows="4" placeholder="请输入退款原因" />
                </el-form-item>
                <el-form-item label="上传图片">
                    <el-upload
                      class="upload-demo"
                      action=""
                      :http-request="uploadImage"
                      :file-list="refundImageList"
                      :on-remove="handleRemoveImage"
                      list-type="picture-card"
                      multiple>
                      <i class="el-icon-plus"></i>
                      <div slot="tip" class="el-upload__tip">可上传jpg/png图片凭证，不超过5MB</div>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="refundDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitRefund" :loading="refundSubmitting">提交申请</el-button>
            </div>
        </el-dialog>
  </div>
</template>

<script>
import bus from "@/components/eventBus.js";
export default {
  name: "SuggestionsView",
  data() {
    return {
      currentIndex: 1,
      currentPage1: 1,
      total: 10,
       navIndex:-1,
       serveNavIndex:0,
       orderList:[],
       keyword:'',
       serveOrderList:[],
       serveOrderIndex:{},
       orderIndex:{},
       loading:false,
       dialogProgressVisible:false,
       progressForm:{
        title:'',
        content:''
       },
       // 退款弹窗数据
       refundDialogVisible: false,
       refundSubmitting: false,
       refundImageList: [],
       currentRefundOrder: null,
       refundForm: {
         order_id: '',
         money: '',
         content: '',
         mobile: '',
         images: []
       },
       refundRules: {
         money: [
           { required: true, message: '请输入退款金额', trigger: 'blur' },
          //  { type: 'number', message: '金额必须为数字', trigger: 'blur' }
         ],
         mobile: [
           { required: true, message: '请输入联系电话', trigger: 'blur' },
           { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
         ],
         content: [
           { required: true, message: '请输入退款原因', trigger: 'blur' }
         ]
       }
    };
  },
  mounted() {
    if(this.$route.query.status){
      this.navIndex = this.$route.query.status;
      this.serveNavIndex = this.$route.query.status;
    }
    if(this.$route.query.type){
      this.currentIndex = this.$route.query.type;
    }
    if(this.currentIndex ==1){
      this.getOrderList();
    }
    this.getServeOrderIndex();
    this.getOrderIndex();
  },
  methods: {
    getServeStatus(status,item){
      switch(status){
        case 0:
          if(item.is_confirmprice==1){
            return '待确认';
          }else{
            return '待后台确认';
          }
        case 1:
          return '进行中';
        case 2:
          return '已完成';
        default:
          return '';
      }
      },
    getServeOrderIndex(){
      this.$api.getServeOrderIndex().then(res => {
        console.log(res);
        if(res.code == 1){
          this.serveOrderIndex = res.data;
        }
      }).catch(err => {
        console.log(err);
      });
    },
     getOrderIndex(){

      this.$api.getOrderIndex().then(res => {
        console.log(res);
        if(res.code == 1){
          this.orderIndex = res.data;
        }
      }).catch(err => {
        console.log(err);
      });
    },
    getOrderList(){
      this.loading = true;
      this.$api.getOrderList({
        status: this.navIndex,
        page: this.currentPage1,
        keyword: this.keyword,
        limit: 10
      }).then(res => {
        console.log(res);
        this.loading = false;
        if(res.code == 1){
          this.orderList = res.data.list;
          this.total = res.data.total;
        }else{
          this.orderList = [];
        }
      }).catch(err => {
        console.log(err);
        this.loading = false;
      }).finally(() => {
        this.loading = false;
      });
     
    },
    getServeOrderList(){
      this.loading = true;
      this.$api.getServeOrderList({
        status: this.serveNavIndex,
        page: this.currentPage1,
        keyword: this.keyword,
        limit: 10
      }).then(res => {
        console.log(res);
        this.loading = false;
        if(res.code == 1){
          this.serveOrderList = res.data.list;
          this.total = res.data.total;
        }else{
          this.serveOrderList = [];
        }
      }).catch(err => {
        console.log(err);
        this.loading = false;
      }).finally(() => {
        this.loading = false;
      });
    },
    serveConfirm(item){
      this.$confirm('确定要确认服务订单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((confirm) => {
        if(confirm){
          this.loading = true;
          this.$api.serveConfirm({
            order_id: item.id
          }).then(res => {
            console.log(res);
            this.loading = false;
            if(res.code == 1){
              this.$message.success(res.message);
              this.serveNavIndex = 0;
              this.currentPage1 = 1;
              this.getServeOrderList();
            }else{
              this.$message.error(res.message);
            }
          }).catch(err => {
            console.log(err);
            this.loading = false;
          }).finally(() => {
            this.loading = false;
          });
        }
      }).catch(err => {
        console.log(err);
        this.loading = false;
      });
    },
    completeServeOrder(item){
      this.$confirm('确定要确认完成服务订单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((confirm) => {
        if(confirm){
          this.loading = true;
          this.$api.completeServeOrder({
            order_id: item.id
          }).then(res => {
            console.log(res);
            this.loading = false;
            if(res.code == 1){
              this.$message.success(res.message);
              this.getServeOrderList();
            }else{
              this.$message.error(res.message);
            }
          }).catch(err => {
            console.log(err);
            this.loading = false;
          }).finally(() => {
            this.loading = false;
          });
        }
      }).catch(err => {
        console.log(err);
        this.loading = false;
      });
    },
    handleSearch() {
      // if (this.keyword.trim() !== '') {
       
      // }
      if(this.currentIndex ==1){

        this.navIndex = -1;
        this.currentPage1 = 1;
        this.getOrderList();
      }else{

        this.serveNavIndex = 0;
        this.currentPage1 = 1;
        this.getServeOrderList();
      }
    },
  
    navClick2(index) {

      this.navIndex = index;
      this.keyword = '';
      this.currentPage1 = 1;
      this.getOrderList();
    },
    serveNavClick2(index){

      this.serveNavIndex = index;
      this.keyword = '';
      this.currentPage1 = 1;
      this.getServeOrderList();
    },
    navClick(index) {
      this.currentIndex = index;

      this.navIndex = -1;
      this.serveNavIndex = 0;
      this.keyword = '';
      this.currentPage1 = 1;
      if(this.currentIndex ==1){
        this.getOrderList();
      }else{
        this.getServeOrderList();
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage1 = val;
      if(this.currentIndex ==1){
        this.getOrderList();
      }else{
        this.getServeOrderList();
      }
    },
    remindDelivery(id){
      this.$api.remindDelivery({
        id: id
      }).then(res => {
        console.log(res);
        this.$message.success(res.message);
      }).catch(err => {
        console.log(err);
      });
    },
    comfirmDelivery(id){
      this.$confirm('确定要确认收货吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.confirmDelivery({
          id: id
        }).then(res => {
          if(res.code == 1){
            this.$message.success(res.message);
            this.getOrderList();
          }else{
            this.$message.error(res.message);
          }
        }).catch(err => {
          console.log(err);
        });
      });
    },
    toOrderDetail(id){
      this.$router.replace({ path: "/myorderinfoview?id=" + id });
    },
    
  
    goServeOrderInfo(item){
      this.$router.replace({ path: "/myserviceorderinfo/"+item.id });
    },
    toPay(item){
      this.$router.replace({ path: "/pay?order_no=" + item.order_no + "&order_type=1" });
    },
    addstep(item){
      this.dialogProgressVisible = true;
      this.progressForm.order_id = item.id;
    },
    submitProgress(){
      this.$api.addStep(this.progressForm).then(res => {
        console.log(res);
        if(res.code == 1){
          this.$message.success(res.message);
          this.dialogProgressVisible = false;
          this.getServeOrderList();
        }else{
          this.$message.error(res.message);
        }
      });
    },
    // 退款相关方法
    refund(item) {
      this.currentRefundOrder = item;
      this.refundForm = {
        order_id: item.id,
        money: item.price || '',
        content: '',
        mobile: '',
        images: []
      };
      this.refundImageList = [];
      this.refundDialogVisible = true;
    },
    // 上传图片处理
    uploadImage(options) {
      const file = options.file;
      
      // 文件类型检查
      if (!file.type.includes('image/')) {
        this.$message.error('请上传图片类型文件');
        return;
      }
      
      // 文件大小检查（5MB）
      if (file.size > 5 * 1024 * 1024) {
        this.$message.error('图片大小不能超过5MB');
        return;
      }
      
      // 调用上传API
      let formData = new FormData();
      formData.append('file', file);
      
      this.$api.upload({
        file: file
      }).then(res => {
        if (res.code === 1) {
          // 上传成功，将图片URL添加到列表中
          this.refundImageList.push({
            name: file.name,
            url: res.data.fullurl
          });
          this.refundForm.images.push(res.data.fullurl);
          this.$message.success('图片上传成功');
        } else {
          this.$message.error(res.message || '上传失败');
        }
      }).catch(err => {
        console.error('上传出错', err);
        this.$message.error('上传出错，请重试');
      });
    },
    // 移除图片
    handleRemoveImage(file) {
      // 从refundImageList和refundForm.images中移除对应图片
      const fileIndex = this.refundImageList.findIndex(item => item.url === file.url);
      if (fileIndex > -1) {
        this.refundImageList.splice(fileIndex, 1);
        this.refundForm.images.splice(fileIndex, 1);
      }
    },
    // 提交退款申请
    submitRefund() {
      this.$refs.refundForm.validate((valid) => {
        if (valid) {
          this.refundSubmitting = true;
          
          this.$api.submitRefund(this.refundForm).then(res => {
            if (res.code === 1) {
              this.$message.success(res.message || '退款申请提交成功');
              this.refundDialogVisible = false;
              // 刷新服务订单列表
              this.getServeOrderList();
            } else {
              this.$message.error(res.message || '退款申请提交失败');
            }
          }).catch(err => {
            console.error('提交出错', err);
            this.$message.error('提交出错，请重试');
          }).finally(() => {
            this.refundSubmitting = false;
          });
        } else {
          this.$message.warning('请完善表单信息');
          return false;
        }
      });
    }
  }
};
</script> 

<style lang="less"  scoped>
.user_body {
  background: #ffffff;
  padding: 25px;
}
.top_nav {
  display: flex;
  flex-direction: row;
}
.title {
  cursor: pointer;
  color: #757575;
  font-size: 16px;
  width: 120px;
}
.title2 {
  cursor: pointer;
  color: #3c9c8f;
  font-size: 16px;
  width: 120px;
}
.title2_success{
  color: #EBEBEB;
}
.search_top {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}
.tabs {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 20px;
}
.input {
  width: 200px;
}
.search-container {
  display: flex;
  align-items: center;
}
.tab_select {
  cursor: pointer;
  color: #3c9c8f;
  font-size: 14px;
}
.tab_nselect {
  cursor: pointer;
  color: #666666;
  font-size: 14px;
}
.s_line {
  margin-left: 15px;
  margin-right: 15px;
  size: 12px;
  color: #999999;
}
.order_item {
  border: 1px solid #3c9c8f;
  margin-top: 10px;
}
.order_item_success{
  border: 1px solid #EBEBEB;
}
.o_t {
  background: #f5faf9;
  padding: 10px;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid rgba(60, 154, 142, 0.05);
}
.o_t_success{
  background: #fff;
  border-bottom: 1px solid #EBEBEB;
}
.order_top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
}
.o_text1 {
  color: #757575;
  font-size: 14px;
}
.o_text2 {
  color: #3c9c8f;
  font-size: 28px;
}
.o_text2_success{
  color: #333;
}
.o_text3 {
  color: #333333;
  font-size: 14px;
  width: 90%;
  word-break: break-all;
}
.o_text4 {
  color: #666666;
  font-size: 14px;
  width: 90%;
  word-break: break-all;
}

.o_text5 {
  color: #3c9c8f;
  font-size: 28px;
  border: 1px solid #3c9c8f;
  margin-top: 10px;
}
.order_info_list {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.order_info_item {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: 20px 20px 20px 36px;
  box-sizing: border-box;
}
.imae_list {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 20px 10px 30px;
  box-sizing: border-box;
}
.order_img {
  width: 80px;
  height: 80px;
}
.order_name_pr {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
  margin-left: 20px;
}
.order_name_pr span:nth-child(odd) {
  color: #333333;
  font-size: 14px;
  line-height: 20px;
}
.order_name_pr span:nth-child(even) {
  color: #666666;
  font-size: 14px;
  line-height: 20px;
  margin-top: 10px;
}
.order_btns {
  display: flex;
  flex-direction: column;
  margin-right: 20px;
}
.order_btns1 {
  cursor: pointer;
  background: #3c9c8f;
  font-size: 14px;
  color: white;
  width: 100px;
  text-align: center;
  height: 25px;
  line-height: 25px;
}
.order_btns2 {
  cursor: pointer;
  background: #ffffff;
  font-size: 14px;
  color: #757575;
  width: 100px;
  text-align: center;
  height: 23px;
  line-height: 25px;
  border: 1px solid #b0b0b0;
  margin-top: 10px;
}
.order_btns3 {
  cursor: pointer;
  background: #ffffff;
  font-size: 14px;
  color: #3c9c8f;
  width: 100px;
  text-align: center;
  height: 25px;
  line-height: 25px;
  margin-top: 10px;
  border: 1px solid #3c9c8f;
}
.footer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
.dialog-footer{
  padding-right: 20px;
}
.upload-demo {
  display: flex;
  flex-wrap: wrap;
}
.el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
.el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
}
</style>
  


